<div class='button-container certify-button'>
    <button class="certify-logs-button outlined-button button-style full-width-button" color="accent" mat-stroked-button (click)="openCertify()" [disabled]="isDisabled">
        Certify logs
    </button>
    <zui-icon icon="warning" class="material-icons notification-flag" inline="true" [ngClass]="warningState(oldestDay)"></zui-icon>
</div>
